import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/regulatory-consultancy-services/components/RegulatoryConsultancyInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
